import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	loadingMoreProjects: {
		id: 'calendar.calendar-renderer.event-renderer.placeholder-renderer.inline-card-create.project-field.loading-more-projects',
		defaultMessage: 'Loading more projects',
		description: 'Message shown when project selection dropdown is loading more project options',
	},
});
